import script from "./CustomPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomPagination.vue?vue&type=script&lang=ts&setup=true"

import "./CustomPagination.vue?vue&type=style&index=0&id=30d3bb78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d3bb78"]])

export default __exports__